import { profileSettings } from '../en';

export const profileSettingsAR: typeof profileSettings = {
  title: 'الملف الشخصي',
  subtitle: 'لحساب البصمة الكربونيٌة CO₂e بأكثر دقة، سنسئلك 2 أسئلة قصيرة.',
  text: 'ما عليك سوى اختيار الإجابة التي تتناسب مع وضعك ؛ يمكنك دائما تعديلها لاحقا.',
  startButton: 'ابدأ',
  submitButton: 'انظر لبصمتك الكربونية',
};
